import React from 'react';
import Logo from '../../common/Logo';

const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const HomeFooter = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  const links = [
    { label: 'Problem', action: () => scrollTo('problem') },
    { label: 'How It Works', action: () => scrollTo('how-it-works') },
    { label: 'Service', action: () => scrollTo('service') },
    { label: 'Pricing', action: () => scrollTo('pricing') },
    { label: 'AI Voice', action: () => scrollTo('ai-voice') },
    { label: 'FAQ', action: () => scrollTo('faq') },
    { label: 'Book a Call', action: () => scrollTo('booking') },
  ];
  return (
    <footer className="border-t" style={{ background: '#052e16', borderColor: '#166534' }}>
      <div className="max-w-5xl mx-auto px-8 lg:px-16 py-10">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-8">
          <button onClick={scrollTop} className="flex items-center gap-3 bg-transparent border-none p-0 cursor-pointer">
            <Logo className="w-7 h-7" />
            <div className="text-left">
              <span className="text-sm font-bold block text-white">Valtivo</span>
              <span className="text-xs" style={{ color: '#86efac' }}>JSM Asset Ops & Helpdesk</span>
            </div>
          </button>
          <nav className="flex flex-wrap gap-x-7 gap-y-3">
            {links.map((l, i) => (
              <button key={i} onClick={l.action} className="text-sm font-medium transition-colors" style={{ color: '#bbf7d0' }}>
                {l.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="pt-6 border-t flex flex-col sm:flex-row justify-between items-start gap-3" style={{ borderColor: '#166634' }}>
          <p className="text-xs" style={{ color: '#4ade80' }}>© 2026 Valtivo. All rights reserved.</p>
          <p className="text-xs max-w-md" style={{ color: '#86efac' }}>
            JSM-based asset management and helpdesk for operations teams. Not affiliated with Atlassian.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;